import { ALERT_TYPES, colors, REFUND_TYPES } from '@nandosaus/constants';
import { findLastIndex, isNull, map } from 'lodash';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import { useState } from 'react';

import { Alert } from '../../alert';
import { Box, Flex } from '../../grid';
import { Button } from '../../button';
import { InputListItem } from '../../input-list-item';
import { P } from '../../typography';

const REFUND_TYPE = [
  {
    label: 'Refund to your original payment method',
    subText:
      'This takes around 5-7 business days to refund on your original payment method (like a debit or credit card, for example).',
    key: REFUND_TYPES.REFUND,
  },
  {
    label: 'Refund as a gift card',
    subText: "We'll be able to refund as a gift card within 24 hours.",
    key: REFUND_TYPES.VOUCHER,
  },
  {
    label: 'Need something else?',
    subText:
      "Let us know any other issues or suggestions you'd like to share (we're open to compliments, too). We'll make sure to respond within 2-3 business days.",
    key: REFUND_TYPES.SUPPORT_TICKET,
  },
];

const SelectRefundType = observer(() => {
  const { OrderHelpStore, MemberStore } = useRootStore();
  const [refundType, setRefundType] = useState(null);

  const isGuestFlow = !MemberStore.isSignedIn;

  return (
    <>
      <P variant={3} mb={1}>
        How would you like your refund?
      </P>
      <Box>
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          backgroundColor="white"
          borderTop={isGuestFlow ? `1px solid ${colors.grey100}` : ''}
        >
          {map(REFUND_TYPE, (item, index) => {
            const showBorder = isGuestFlow ? true : index !== findLastIndex(REFUND_TYPE);

            if (!OrderHelpStore.order.isRefundableAsGiftCard && item.key === REFUND_TYPES.VOUCHER) {
              return null;
            }

            return (
              <Flex
                alignItems="flex-start"
                py={1}
                mx={isGuestFlow ? 0 : 1}
                borderBottom={showBorder ? `solid 1px ${colors.grey100}` : ''}
                key={index}
                width={isGuestFlow ? '100%' : undefined}
              >
                <InputListItem
                  name={item.label}
                  type="radio"
                  label=""
                  selected={refundType === item.key}
                  value={item.key}
                  onSelect={() => setRefundType(item.key)}
                  py="0"
                >
                  <Flex flexDirection="column">
                    <P variant={2} mb="0.5rem">
                      {item.label}
                    </P>
                    <P variant={3} color="grey500">
                      {item.subText}
                    </P>
                  </Flex>
                </InputListItem>
              </Flex>
            );
          })}
        </Flex>

        <Button
          mt={1}
          onClick={async () => {
            OrderHelpStore.setRefundType(refundType);
            await OrderHelpStore.submitRequest();
            if (OrderHelpStore.error || OrderHelpStore.refusalReasonCode) {
              return;
            }
            OrderHelpStore.goForward();
          }}
          isLoading={!!OrderHelpStore.loading}
          disabled={isNull(refundType)}
        >
          submit
        </Button>
      </Box>
      {OrderHelpStore.error || OrderHelpStore.refusalReasonCode ? (
        <Box pt={2} pb="1.5rem">
          <Alert type={ALERT_TYPES.ERROR}>
            <P variant={3}>An error occurred while processing your request</P>
          </Alert>
        </Box>
      ) : null}
    </>
  );
});

export { SelectRefundType };
